import React from 'react';
import dummyImage from '../../styles/images/trustpilot.svg';
import { Translate } from "react-redux-i18n";
export default function TrustpilotRating() {
    return (
        <section>
            <div className="main-container trustpilot-container">
                <span className="truspilot-text"><Translate value="home.trustpilot_rating"/></span>
                <img src={dummyImage} alt="ihopa TrustPilot"/>
            </div>
        </section>
    )
}
